import { tv } from 'tailwind-variants'

import { caption } from '@ui-kit/core/typography'

export const inlineNotification = tv({
  slots: {
    container: 'flex flex-row items-center gap-x-1',
    text: caption(),
    svg: '',
  },
  variants: {
    type: {
      error: {
        container: 'text-ui-red',
        text: 'text-ui-red',
        svg: 'fill-ui-red',
      },
      success: {
        container: 'text-ui-green',
        text: 'text-ui-green',
        svg: 'fill-ui-green',
      },
      warning: {
        container: 'text-ui-orange',
        text: 'text-ui-orange',
        svg: 'fill-ui-orange',
      },
    },
  },
})
